import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { WizardService, NavigateArgs } from 'src/app/wizard-bar/services/wizard.service';
import { Observable, forkJoin, Subscription, Subscriber } from 'rxjs';
import { QuoteRequestState } from 'src/app/shared/models/quote-request-state';
import { MatTableDataSource } from '@angular/material/table';
import { UtilityAccount } from 'src/app/shared/models/UtilityAccount';
import { ConsumptionFile } from 'src/app/filemanagement/UdFile';
import { UploadErrorEvent } from 'src/app/filemanagement/components/upload/upload.component';
import { QuoteRequestService } from '@app/shared/services/quote-request.service';
import { Store } from '@ngrx/store';
import { UserRole, UtilityHubIdentity } from '@auth/models/utility-hub-identity';
import { QuoteRequestStatus } from '@app/shared/models/quote-request-status';
import { DateConstants } from '@app/constants/date-constants';
import { UtilityAccountService } from '@app/shared/services/utility-account.service';
import { SignalRService } from '@app/shared/services/signalr.service';
import { UtilityInformationService } from '@app/shared/services/utility-information.service';
import { UtilityRateCode } from '@app/shared/models/utility-rate-code';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmComponent } from '@app/shared/components/confirm/confirm.component';
import { UploadService } from '@app/filemanagement/upload.service';
import { ApplyToAllComponent } from '@app/shared/components/apply-to-all/apply-to-all.component';
import { FieldValueConstants } from '@app/shared/models/field-value-constants';
import { UploadDialogComponent } from '@app/filemanagement/upload-dialog/upload-dialog.component';
import { CustomService } from '@app/custom/services/custom.service';
import { CommodityType } from '@app/shared/enums/commodity-type';
import { PricingSource, PricingSourceService } from '@app/shared/services/pricing-source.service';
import { QuoteRequestType } from '@app/shared/models/QuoteRequestType';
import { CustomConstants } from '@app/custom/models/custom-constants';
import LogRocket from 'logrocket';
import { AlertComponent } from '@app/shared/components/alert/alert.component';
import { UsageSource } from '@app/shared/enums/usage-source';
import { UsageSourceMap } from '@utility-information/models/usage-source-map';
import { AppState } from '@app/state/app.state';
import { salesTypeSelector } from '@utility-information/state/selectors/utility-information.selectors';
import {
  loggedInUserSelector,
  loggedInUtilityHubIdentitySelector,
  configurationSelector,
  selectRequireLetterOfAuthorityForMeterVault,
} from '@app/state/app.selectors';
import { SetCommodityType, SetUsageSources } from '@utility-information/state/actions/utility-information.actions';
import { RenewalsRateCodeMapItem } from '../../models/renewals-rate-code-map-item';
import { RenewalsLoaExists } from '../../models/renewals-loa-exists';
import { RenewalsRequestedUsageDataResult } from '../../models/renewals-requested-usage-data-result';
import { RenewalsRequestedUsageDataError } from '../../models/renewals-requested-usage-data-error';
import { originalQuoteRequestIdSelector } from '@app/renewals/state/selectors/renewals-module.selectors';
import { SetOriginalQuoteRequestId } from '@app/renewals/state/actions/renewals-module.actions';

@Component({
  selector: 'app-renewals-custom-consumption-upload',
  templateUrl: './renewals-custom-consumption-upload.component.html',
  styleUrls: ['./renewals-custom-consumption-upload.component.scss'],
})
export class RenewalsCustomConsumptionUploadComponent implements OnInit, OnDestroy {
  @ViewChild(ApplyToAllComponent) applyToAll: ApplyToAllComponent;
  public Commodity = CommodityType;
  public dateFormat = DateConstants.LOCALE_FORMAT_SHORT();
  public quoteRequestId: any;
  public usageSourceMaps: UsageSourceMap[];
  public quoteRequestState: QuoteRequestState;
  public dataSource: MatTableDataSource<UtilityAccount>;

  // Valid number of UAN with uploaded data.
  public validMeterCount = 0;
  public outstandingRequestedDataCount = 0;
  public meterCount = 0;
  public parsingErrorMessages: { id?: string; message: string }[] = [];
  public parseRequestData: any;
  public pricesGenerated: boolean;
  public meterVaultEnabled: boolean;
  public fetchingRateCodes = true;

  public displayedColumns: string[] = [
    'utilityAccountNumber',
    'rateCode',
    'fileName',
    'dateRequested',
    'lastModified',
    'status',
    'remove',
    'requestConsumptionData',
  ];
  userIdentity: UtilityHubIdentity;

  public resolveWaitForUploadConfirmation: () => Observable<boolean>;
  rateCodeDetails: UtilityRateCode[];
  selectedRateCodeMap: UtilityRateCode[];
  initialRateCodeMap: RenewalsRateCodeMapItem[];
  rateCode: any;
  disableRateCode: any;
  overwriteData$: Observable<boolean>;
  selectLoggedInUserSubscription$: Subscription;
  signalRUsageDataSubscription$: Subscription;
  signalRUsageDataErrorSubscription$: Subscription;
  routeSubscription$: Subscription;
  selectLoggedInUtilityHubIdentitySubscription$: Subscription;
  loadSubscription$: Subscription;
  overwriteDataSubscription$: Subscription;
  forceParseConsumptionDataSubscription$: Subscription;
  saveRateCodeSubscription$: Subscription;
  requestConsumptionDataForAccountsSubscription$: Subscription;
  loaExists: RenewalsLoaExists;
  uploadDialog: MatDialogRef<UploadDialogComponent>;
  uploadDialog$: Subscription;
  salesType$: Observable<string>;
  isFileUploaded: boolean;
  requireLetterOfAuthority: boolean;
  //requireLetterOfAuthority$: Subscription;
  originalQuoteRequestIdSelector$: Subscription;
  originalQuoteRequestId: number | null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private wizardService: WizardService,
    private utilityAccountService: UtilityAccountService,
    private signalRService: SignalRService,
    public quoteService: QuoteRequestService,
    private store: Store<AppState>,
    private utilityInformationService: UtilityInformationService,
    protected dialog: MatDialog,
    private uploadService: UploadService,
    private customQuoteService: CustomService,
    private pricingSourceService: PricingSourceService
  ) {
    this.salesType$ = store.select(salesTypeSelector);
  }

  isGasQuote(): boolean {
    return this.quoteRequestState && this.quoteRequestState.commodity == CommodityType.Gas;
  }

  ngOnDestroy(): void {
    this.selectLoggedInUserSubscription$?.unsubscribe();
    this.signalRUsageDataSubscription$?.unsubscribe();
    this.signalRUsageDataErrorSubscription$?.unsubscribe();
    this.routeSubscription$?.unsubscribe();
    this.selectLoggedInUtilityHubIdentitySubscription$?.unsubscribe();
    this.loadSubscription$?.unsubscribe();
    this.overwriteDataSubscription$?.unsubscribe();
    this.forceParseConsumptionDataSubscription$?.unsubscribe();
    this.saveRateCodeSubscription$?.unsubscribe();
    this.requestConsumptionDataForAccountsSubscription$?.unsubscribe();
    //this.requireLetterOfAuthority$.unsubscribe();
    this.originalQuoteRequestIdSelector$.unsubscribe();
  }

  ngOnInit(): void {
    this.signalRService.startConnection('usageData');
    this.signalRUsageDataSubscription$ = this.signalRService
      .addListener<RenewalsRequestedUsageDataResult>('utilityAccountWithUsageData')
      .subscribe((data) => this.handleSignalRResponse(data));
    this.signalRUsageDataErrorSubscription$ = this.signalRService
      .addListener<RenewalsRequestedUsageDataError>('utilityAccountWithUsageDataErrored')
      .subscribe((data) => this.handleSignalRErrorResponse(data));
    this.wizardService.bindStep(this.route, (args) => this.save(args));

    this.routeSubscription$ = this.route.params.subscribe((x) => {
      this.quoteRequestId = null;
      if (!isNaN(x.quoteRequestId)) {
        this.quoteRequestId = Number(x.quoteRequestId);

        this.load();
      }
    });

    this.selectLoggedInUserSubscription$ = this.store.select(loggedInUserSelector).subscribe((user) => {
      if (user && !user.expired) {
        this.selectLoggedInUtilityHubIdentitySubscription$ = this.store.select(loggedInUtilityHubIdentitySelector).subscribe((uhUser) => {
          this.userIdentity = uhUser;
        });
      }
    });

    this.store.select(configurationSelector).subscribe((config) => {
      this.meterVaultEnabled = config.supplierConfiguration.meterVaultEnabled;
    });

    this.originalQuoteRequestIdSelector$ = this.store.select(originalQuoteRequestIdSelector).subscribe((originalQuoteRequestId) => {
      this.originalQuoteRequestId = originalQuoteRequestId;
    });

    // this.requireLetterOfAuthority$ = this.store.select(selectRequireLetterOfAuthorityForMeterVault).subscribe((config) => {
    //   this.requireLetterOfAuthority = config;
    // });

    this.resolveWaitForUploadConfirmation = () => {
      const warningRequired = this.wizardService.resolveExpireQuoteWarningDialog(this.isQuoteRequestInvalidated());
      if (warningRequired.required) {
        return warningRequired.dialogRef.afterClosed();
      } else {
        return new Observable<any>((obs) => {
          obs.next(true);
          obs.complete();
        });
      }
    };
  }

  public isRequestDataBtnDisabledForAll() {
    return (
      this.outstandingRequestedDataCount + this.validMeterCount === this.meterCount ||
      this.isUtilityShortIDontKnow() ||
      this.fetchingRateCodes
    );
  }

  public isRequestDataBtnDisabledForOne(uan: UtilityAccount) {
    return (
      uan.consumptionData.consumptionDataReceived ||
      uan.consumptionData.consumptionDataRequested ||
      (this.isUtilityShortIDontKnow() && !uan.consumptionData.consumptionDataRequestedErrored) ||
      this.fetchingRateCodes
    );
  }

  private createUsageSourceMaps() {
    let usageSourceMaps = [];
    this.dataSource.data.forEach((ua) => {
      usageSourceMaps.push({
        utilityAcctNumber: ua?.utilityAccountNumber,
        usageSource: ua?.consumptionData?.dataFile?.fileName ? UsageSource.FILE_UPLOAD : UsageSource.METER_VAULT,
      });
    });
    return usageSourceMaps;
  }

  private isUtilityShortIDontKnow() {
    return this.dataSource.data.filter((x) => x.utilityDetails?.utilityShort === FieldValueConstants.IDontKnow).length > 0;
  }

  private load() {
    this.loadSubscription$ = forkJoin({
      state: this.quoteService.getQuoteRequestState(this.quoteRequestId),
      meters: this.quoteService.getUtilityAccounts(this.quoteRequestId),
      loaExists: this.quoteService.checkLoaExists(this.quoteRequestId),
    }).subscribe((res) => {
      this.quoteRequestState = res.state;
      this.store.dispatch(new SetOriginalQuoteRequestId(this.quoteRequestState.renewedFromQuoteId));
      this.meterCount = res.meters.length;
      this.dataSource = new MatTableDataSource(res.meters);
      this.initialRateCodeMap = res.meters.map((x) => new RenewalsRateCodeMapItem(x.utilityAccountNumber, x.rateCode));
      this.pricesGenerated = res.state.prices.length > 0 || res.state.status === QuoteRequestStatus.QuoteRequested;
      this.validMeterCount = res.meters.filter((x) => x.consumptionData.consumptionDataReceived).length;
      this.outstandingRequestedDataCount = res.meters.filter((x) => x.consumptionData.consumptionDataRequested).length;

      this.loaExists = res.loaExists.loaExists;

      this.parseRequestData = {
        parserName: this.quoteRequestState.commodity === CommodityType.Gas ? 'GasFileParser' : 'StandardScalarFileParser',
        quoteRequestId: this.quoteRequestId,
      };

      this.store.dispatch(new SetCommodityType(this.quoteRequestId, this.quoteRequestState.commodity));

      // Fetch Utility rate code info
      this.utilityInformationService.getUtilityRateCodes(this.quoteRequestId).subscribe(
        (rateCodes) => {
          this.fetchingRateCodes = false;
          this.rateCodeDetails = rateCodes;

          this.pricingSourceService.getPricingSource(QuoteRequestType.Custom, this.quoteRequestState.commodity).subscribe((ps) => {
            if (ps.source === PricingSource.Dynamic) {
              this.rateCodeDetails.push({ rateCode: FieldValueConstants.IDontKnow, rateClass: FieldValueConstants.IDontKnow });
            }
          });

          if (this.isUtilityShortIDontKnow()) {
            this.dataSource.data.forEach((x) => {
              x.rateCode = FieldValueConstants.IDontKnow;
              x.rateCode = FieldValueConstants.IDontKnow;
            });
          }
        },
        (err) => {
          this.fetchingRateCodes = false;
        }
      );
    });
  }

  public onDeleteConsumptionDataUpload(file: ConsumptionFile) {
    this.load();
  }

  public onCompleteUpload(files: ConsumptionFile[]) {
    // Map parsing error messages to table
    this.parseErrors(files, null);

    const utilityAccountWithExistingData = this.getUansWithExistingData(files);
    if (utilityAccountWithExistingData.size > 0) {
      this.overwriteData$ = this.shouldOverWriteExistingConsumptionData(utilityAccountWithExistingData);

      this.overwriteDataSubscription$ = this.overwriteData$.subscribe((confirmed) => {
        var uans = [...utilityAccountWithExistingData.keys()];
        var documentId = [...utilityAccountWithExistingData.values()][0];

        // If cancelling then we should remove the file
        if (!confirmed) {
          return;
        }

        this.forceParseConsumptionDataSubscription$ = this.uploadService
          .forceParseConsumptionData(this.quoteRequestId, uans, documentId)
          .subscribe(() => {
            this.processUpload(files, confirmed);
            files.filter((f) => {
              f.data.errors = f.data.errors.filter((e) => f.fileId === documentId && e.errorCode === 'DATA_EXISTS');
              this.parsingErrorMessages = this.parsingErrorMessages.filter((em) => {
                em.message.includes('- data already exists') && uans.includes(em.message);
              });
            });
          });
      });
    } else {
      files.forEach((f) =>
        f.data.errors.forEach((e) => {
          this.parsingErrorMessages.push({ message: e.message });
        })
      );
      this.processUpload(files, false);
    }

    // Set UsageSource to FILE_UPLOAD
    //this.store.dispatch(new SetUsageSource(this.quoteRequestId, UsageSource.FILE_UPLOAD));
    this.store.dispatch(new SetUsageSources(this.quoteRequestId, this.createUsageSourceMaps()));
  }

  public processUpload(files: ConsumptionFile[], confirmedOverwrite: boolean) {
    // Map found data files to UANs.
    const dataSource = this.dataSource.data;
    files.forEach((file) => {
      if (!file.data.data) {
        return;
      }

      const uans = dataSource.filter((x) => file.data.data.find((d) => d.meterIdentifier === x.utilityAccountNumber));

      uans.forEach((uan) => {
        if (confirmedOverwrite || (!uan.consumptionData.consumptionDataReceived && !uan.consumptionData.consumptionDataRequested)) {
          const fileName = file.data.fileName;
          uan.consumptionData.source = 'File';
          let loadProfile = file.data.data
            .find((x) => x.meterIdentifier == uan.utilityAccountNumber)
            .consumption.find((y) => y.loadProfile?.length > 0)?.loadProfile;

          uan.consumptionData.dataFile = { ...file, fileName, documentName: fileName, fileId: file.data.fileId };
          uan.consumptionData.consumptionDataReceived = true;
          this.setRateCodeAndRateClass(loadProfile, uan);
          const rateCodes = [{ utilityAccountNumber: uan.utilityAccountNumber, rateCode: uan.rateCode, rateClass: uan.rateClass }];
          this.quoteService.saveRateCodes(this.quoteRequestId, rateCodes).subscribe().unsubscribe();
        }
      });

      if (uans.length === 0) {
        this.parsingErrorMessages.unshift({ message: `${file.name} - No accounts found` });
      }
    });

    // Update valid count
    this.validMeterCount = dataSource.filter((x) => x.consumptionData?.consumptionDataReceived).length;

    // Update table.
    this.dataSource = new MatTableDataSource(dataSource);
  }

  trimLeadingZeroes(value: string) {
    return value.replace(/^0+/, '');
  }

  public getUansWithExistingData(files) {
    let erroredUans: Map<string, string> = new Map<string, string>();
    files.forEach((file) => {
      if (file.data.errors.filter((x) => x.errorCode.includes('DATA_EXISTS')).length > 0) {
        file.data.errors.forEach((error) => {
          erroredUans.set(error.message, error.dataItem);
        });
      }
    });
    return erroredUans;
  }

  public shouldOverWriteExistingConsumptionData(erroredUANumbers): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: '25%',
      data: {
        title: 'Overwrite Existing Usage Data',
        message:
          'You already have usage data associated with the following utility account numbers.  Would you like to overwrite this data?',
        primaryButtonText: 'Overwrite usage data',
        listData: erroredUANumbers,
      },
    });

    return dialogRef.afterClosed();
  }

  public onUploadError(error: UploadErrorEvent) {
    this.parseErrors(error.files, error.errorCode);
  }

  public parseErrors(files, errorCode) {
    files.forEach((file) => {
      if (errorCode === 'WrongFileType') {
        this.parsingErrorMessages.unshift({ message: `${file.name} - File type not supported` });
      } else if (file.data.errors.filter((x) => x.errorCode.includes('maximum file size')).length > 0) {
        this.parsingErrorMessages.unshift({ message: `${file.name} - Maximum file size exceeded` });
      } else if (file.data.errors.filter((x) => x.errorCode.includes('DATA_EXISTS').length > 0)) {
        const dataExistsUas = file.data.errors.filter((y) => y.errorCode.includes('DATA_EXISTS'));
        const dataExistsUans = dataExistsUas.map((z) => z.message);
        dataExistsUans.forEach((dataExistsUan) => {
          const message = `${dataExistsUan} - data already exists`;
          if (!this.parsingErrorMessages.includes({ message })) {
            this.parsingErrorMessages.unshift({ message });
          }
        });
      } else {
        this.parsingErrorMessages.unshift({ message: `${file.name} - Could not parse file` });
      }
    });
  }

  public isSelected(rateCode: UtilityRateCode, index: number) {
    return this.dataSource.data[index]?.rateCode?.trim() === rateCode?.rateCode?.trim();
  }

  public isRateCodeDisabled(index: number) {
    return (
      this.dataSource.data[index].consumptionData.source !== 'File' &&
      this.dataSource.data[index].consumptionData.consumptionDataReceived &&
      this.quoteRequestState.commodity === CommodityType.Electricity &&
      this.initialRateCodeMap[index].rateCode &&
      this.initialRateCodeMap[index].rateCode != FieldValueConstants.IDontKnow
    );
  }

  public rateCodeChanged(eventData: any, record: UtilityAccount) {
    const selectedValue = eventData.target.selectedOptions[0].value;

    this.setRateCodeAndRateClass(selectedValue, record);

    // only show apply to all where there is more than one ua that may have its rate code updated
    if (
      this.dataSource.data.filter((x) => !x.consumptionData.consumptionDataRequested && !x.consumptionData.consumptionDataReceived).length >
      1
    ) {
      this.applyToAll.generateApplyToAllPrompt('Load Profile', selectedValue, 'rateCode', 'rateCode');
    }
  }

  public isRateCodeInvalid(rateCode: UtilityRateCode): boolean {
    return !rateCode.rateCode || rateCode.rateCode == FieldValueConstants.IDontKnow;
  }

  public isDifferent(initialCodes: RenewalsRateCodeMapItem[], currentCodes: RenewalsRateCodeMapItem[]) {
    if (initialCodes.length !== currentCodes.length) {
      return true;
    }
    for (let initialCode of initialCodes) {
      if (
        currentCodes.filter(
          (x) => x.rateCode.trim() === initialCode.rateCode.trim() && x.utilityAccountNumber === initialCode.utilityAccountNumber
        ).length === 0
      ) {
        if (initialCode.rateCode !== "I don't know") {
          return true;
        }
      }
    }
    return false;
  }

  public save(args: NavigateArgs): Observable<any> {
    const navigateWithoutSave: (obs: Subscriber<any>, arg: NavigateArgs) => void = (obs, arg) => {
      if ((arg.direction && arg.direction < 0) || this.wizardService.clickedStepIsPreviousStep(CustomConstants.wizardSteps, arg.step)) {
        obs.next(true);
      } else {
        obs.next(false);
      }
      obs.complete();
    };

    // may not be the best place for this.  Apply to all does not set the rate class so adding it here
    if (this.rateCodeDetails) {
      this.dataSource.data.forEach((uaRecord) => {
        const detail = this.rateCodeDetails.filter((x) => x.rateCode.trim() === uaRecord.rateCode.trim());
        uaRecord.rateClass = detail?.length > 0 ? detail[0].rateClass : '';
      });
    }

    return new Observable((obs) => {
      if (
        this.validMeterCount === this.meterCount ||
        this.isUtilityShortIDontKnow() ||
        this.userIdentity.currentOrganisation.role === UserRole.SupplierManager
      ) {
        if (this.dataSource.data.filter((row) => row.rateCode === null).length === 0) {
          const rateCodes: { utilityAccountNumber: string; rateCode: string; rateClass: string }[] = this.dataSource.data.map((row) => {
            return { utilityAccountNumber: row.utilityAccountNumber, rateCode: row.rateCode, rateClass: row.rateClass };
          });

          this.saveRateCodeSubscription$ = this.quoteService.saveRateCodes(this.quoteRequestId, rateCodes).subscribe((quoteRequestId) => {
            obs.next(true);
            obs.complete();
          });
        } else {
          navigateWithoutSave(obs, args);
        }
      } else {
        navigateWithoutSave(obs, args);
      }
    });
  }

  public next() {
    if (this.validMeterCount !== this.meterCount) {
      this.dialog.open(AlertComponent, {
        width: '30%',
        data: {
          title: 'Missing Usage',
          message: 'Please provide usage data for all Utility Accounts',
        },
      });
      return;
    }
    this.wizardService.next(this.isQuoteRequestInvalidated());
  }

  public back() {
    this.wizardService.previous(this.isQuoteRequestInvalidated());
  }

  public getParsingErrorMessages() {
    if (!this.meterVaultEnabled) {
      return this.parsingErrorMessages.map((x) => {
        if (x.message.endsWith('.')) {
          return x.message.substring(0, x.message.length - 1);
        } else {
          return x.message;
        }
      });
    } else {
      return null;
    }
  }

  public isReadOnly() {
    return this.quoteService.isReadonly(this.quoteRequestId, this.quoteRequestState?.status, this.userIdentity?.id, this.quoteRequestState?.ownerUserId);
  }

  public isQuoteRequestInvalidated() {
    return this.pricesGenerated && this.isDirty();
  }

  private isDirty(): boolean {
    const currentRateCodeMap = this.dataSource.data.map((x) => new RenewalsRateCodeMapItem(x.utilityAccountNumber, x.rateCode));

    const different = this.isDifferent(this.initialRateCodeMap, currentRateCodeMap);

    return different;
  }

  public requestConsumptionDataForSingleAccount(utilityAccount: UtilityAccount) {
    if (this.isUtilityShortIDontKnow()) {
      return;
    }
    if (this.loaExists || !this.requireLetterOfAuthority) {
      this.requestConsumptionData(utilityAccount);
      return;
    } else {
      this.uploadDialog = this.dialog.open(UploadDialogComponent, {
        width: '40%',
        data: {
          title: `Please upload an LOA for ${this.userIdentity.currentOrganisation.name} - ${this.quoteRequestState.quoteRequestId}`,
          description: 'A letter of authority (LOA) is required to request usage data.  Please upload your LOA below to continue.',
          uploadBoxDescription: 'Drag and drop your LOA here',
          noFileUploadedErrorMessage: 'Please upload an LOA.',
        },
      });
    }

    this.uploadDialog$ = this.uploadDialog.afterClosed().subscribe((result) => {
      if (result.success) {
        this.attachLoaDocuments(result);
        this.requestConsumptionData(utilityAccount);
      }
    });

    // Update store - SET Usage to "METER_VAULT"
    //this.store.dispatch(new SetUsageSources(new ({ this.quoteRequestId.toString(), UsageSource.METER_VAULT }));
    this.store.dispatch(new SetUsageSources(this.quoteRequestId, this.createUsageSourceMaps()));
  }

  public requestConsumptionData(utilityAccount: UtilityAccount = null) {
    if (this.isUtilityShortIDontKnow()) {
      return;
    }

    let uans: Array<UtilityAccount> = [];
    if (utilityAccount) {
      const uan = this.dataSource.data.find((x) => x.utilityAccountNumber === utilityAccount.utilityAccountNumber);
      uans.push(uan);
    } else {
      uans = this.dataSource.data.filter((x) => !x.consumptionData.consumptionDataRequested && !x.consumptionData.consumptionDataReceived);
    }

    if (uans?.length > 0) {
      LogRocket.track('feature:metervault');
      this.requestConsumptionDataForAccountsSubscription$ = this.utilityAccountService
        .requestConsumptionDataForAccounts(this.quoteRequestId, uans)
        .subscribe((res) => {
          uans.forEach((uan) => {
            this.markAsRequested(uan);
          });
        });
    }
  }

  public requestConsumptionDataForAllAccounts() {
    if (this.isUtilityShortIDontKnow()) {
      return;
    }

    if (this.loaExists || !this.requireLetterOfAuthority) {
      return this.requestConsumptionData();
    } else {
      this.uploadDialog = this.dialog.open(UploadDialogComponent, {
        width: '40%',
        data: {
          title: `Please upload an LOA for ${this.userIdentity.currentOrganisation.name} - ${this.quoteRequestState.quoteRequestId}`,
          description: 'A letter of authority (LOA) is required to request usage data.  Please upload your LOA below to continue.',
          uploadBoxDescription: 'Drag and drop your LOA here',
          noFileUploadedErrorMessage: 'Please upload an LOA.',
        },
      });
    }

    this.uploadDialog$ = this.uploadDialog.afterClosed().subscribe((result) => {
      if (result.success) {
        this.attachLoaDocuments(result);
        this.requestConsumptionData();
      }
    });

    // Update store - SET Usage to "METER_VAULT"
    //this.store.dispatch(new SetUsageSources(this.quoteRequestId.toString(), UsageSource.METER_VAULT));
    this.store.dispatch(new SetUsageSources(this.quoteRequestId, this.createUsageSourceMaps()));
  }

  private attachLoaDocuments(fileUploadResult: any) {
    this.customQuoteService
      .attachLoaDocuments(
        this.quoteRequestId,
        fileUploadResult.files.map((x) => x.fileId)
      )
      .subscribe(() => {
        this.quoteService.checkLoaExists(this.quoteRequestId).subscribe((x) => (this.loaExists = x.loaExists));
      });
  }

  private markAsRequested(uan: UtilityAccount) {
    uan.consumptionData.consumptionDataRequested = true;
    uan.consumptionData.consumptionDataRequestedErrored = false;
    uan.consumptionData.dateRequested = new Date();
    uan.consumptionData.lastModified = new Date();
    this.incrementRequestDataCount();
  }

  private setRateCodeAndRateClass(selectedValue: string, record: UtilityAccount) {
    let detail = this.rateCodeDetails.filter((x) => x.rateCode.trim() === selectedValue?.trim());
    if (detail.length > 0) {
      record.rateCode = selectedValue;
      record.rateClass = detail[0].rateClass;
    } else {
      record.rateCode = FieldValueConstants.IDontKnow;
      record.rateClass = FieldValueConstants.IDontKnow;
    }
  }

  public handleSignalRResponse(result: RenewalsRequestedUsageDataResult) {
    const utilityAccount = this.dataSource.data.find((x) => x.utilityAccountNumber === result.utilityAccountNumber);
    if (utilityAccount) {
      console.log(utilityAccount.utilityDetails?.utilityShort + '_' + result.rateCode, 'UsageDataResult');
      this.utilityInformationService.getRateCodeFromLoadProfile(result.rateCode, utilityAccount.utilityDetails?.utilityShort).subscribe((rateCode) => {
        this.setRateCodeAndRateClass(rateCode, utilityAccount);

        const rateCodes = [
          {
            utilityAccountNumber: utilityAccount.utilityAccountNumber,
            rateCode: utilityAccount.rateCode,
            rateClass: utilityAccount.rateClass,
          },
        ];
        this.quoteService.saveRateCodes(this.quoteRequestId, rateCodes).subscribe().unsubscribe();
      });

      utilityAccount.consumptionData.consumptionDataRequested = false;
      utilityAccount.consumptionData.consumptionDataRequestedErrored = false;
      utilityAccount.consumptionData.consumptionDataReceived = true;
      utilityAccount.consumptionData.lastModified = new Date();
      this.decrementRequestDataCount();
      this.validMeterCount++;
    }
  }
  public handleSignalRErrorResponse(result: RenewalsRequestedUsageDataError) {
    console.log('UsageDataResultFail');
    const utilityAccount = this.dataSource.data.find((x) => x.utilityAccountNumber === result.utilityAccountNumber);

    if (utilityAccount) {
      utilityAccount.consumptionData.consumptionDataRequested = false;
      utilityAccount.consumptionData.consumptionDataRequestedErrored = true;
      utilityAccount.consumptionData.lastModified = new Date();

      let message = '';
      switch (result.meterVaultRequestType) {
        case 'UsageHistoryPlus':
          message = `${result.utilityAccountNumber} - Usage could not be found`;
          break;
        case 'MeterAttributes':
          message = `${result.utilityAccountNumber} - Utility Account details could not be found`;
          break;
      }

      if (!this.parsingErrorMessages.some((x) => result.correlationId === x.id)) {
        this.parsingErrorMessages.push({ id: result.correlationId, message: message });
        this.decrementRequestDataCount();
      }
    }
  }

  private incrementRequestDataCount() {
    this.outstandingRequestedDataCount++;
  }

  private decrementRequestDataCount() {
    this.outstandingRequestedDataCount--;
    if (this.outstandingRequestedDataCount < 0) {
      this.outstandingRequestedDataCount = 0;
    }
  }

  importCurrentUsageData() {}

  downloadCurrentUsageDataFile() {}
}
